import { type IHosRuleset } from "hos-tools";
import { type IHosProcessResult } from "../../../services/hosProcess";

export type ISplitSleeperAvailability = Pick<IHosProcessResult, "availability" | "preciseAvailability">;

export function isSplitSleeperToggleAvailable(
    isFeatureFlagEnabled: boolean,
    ruleset: DeepReadonly<IHosRuleset> | undefined
): boolean {
    return isFeatureFlagEnabled && ruleset?.config.splitConfig !== undefined;
}

export function getSplitSleeperAvailability(
    result: IHosProcessResult,
    splitSleeperEnabled: boolean
): ISplitSleeperAvailability {
    if (!splitSleeperEnabled && result.nonSplitAvailability && result.nonSplitPreciseAvailability) {
        return {
            availability: result.nonSplitAvailability,
            preciseAvailability: result.nonSplitPreciseAvailability
        };
    }

    return {
        availability: result.availability,
        preciseAvailability: result.preciseAvailability
    };
}
